import { render, staticRenderFns } from "./SplitTest.vue?vue&type=template&id=d8e96fe2&scoped=true"
import script from "./SplitTest.vue?vue&type=script&lang=js"
export * from "./SplitTest.vue?vue&type=script&lang=js"
import style0 from "./SplitTest.vue?vue&type=style&index=0&id=d8e96fe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8e96fe2",
  null
  
)

export default component.exports